import { captureException, captureMessage } from '@sentry/browser';
export default class SentryStream {
    write(record) {
        const level = this.getSentryLevel(record);
        if (record.err) {
            captureException(this.deserializeError(record.err), { level });
        }
        else {
            captureMessage(record.msg, { level });
        }
    }
    getSentryLevel(record) {
        let level = record?.level || 0;
        if (typeof level === 'string') {
            level = parseInt(level);
        }
        if (level >= 60)
            return 'fatal';
        if (level >= 50)
            return 'error';
        if (level >= 40)
            return 'warning';
        return 'info';
    }
    /**
     * Error deserialiazing function. Bunyan serialize the error to object
     */
    deserializeError(data) {
        if (data instanceof Error)
            return data;
        const error = new Error(data.message);
        error.name = data.name;
        error.stack = data.stack;
        return error;
    }
}
